import { slice } from './slice';

const { reducer } = slice;

export * as commonSelectors from './selectors';
export * from './thunks';

export default reducer;
